import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgReparatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Reparatie_svg__a)">
      <mask
        id="Reparatie_svg__b"
        width={34}
        height={34}
        x={3}
        y={3}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M5.93 24.17a7 7 0 0 1 6.78-1.83l9.63-9.63A7.06 7.06 0 0 1 31 4.09L26.65 8.4l5 4.95L35.91 9a7.062 7.062 0 0 1-8.62 8.62l-9.63 9.63A7.06 7.06 0 0 1 9 35.91l4.31-4.31-4.95-5L4.09 31a7 7 0 0 1 1.84-6.83"
        />
      </mask>
      <g mask="url(#Reparatie_svg__b)">
        <path
          fill="#F7A941"
          d="m27.72 51.03-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="m22.54 31.71-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#F7A941"
          d="m47.04 45.85-12.25-7.07 7.07-12.24z"
        />
        <path
          fill="#F18700"
          d="m22.54 31.71 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m41.86 26.54-7.07 12.24-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="M17.36 12.39 5.12 5.32l7.07-12.24zM-7.13-1.75 5.12 5.32l-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="M-1.95 17.57 5.12 5.32l12.24 7.07zM12.19-6.92 5.12 5.32-7.13-1.75z"
        />
        <path
          fill="#F18700"
          d="M36.68 7.22 24.43.15l7.08-12.25zM12.19-6.92 24.43.15l-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="M17.36 12.39 24.43.15l12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m17.36 12.39 12.25 7.07-7.07 12.25zM41.86 26.54l-12.25-7.08 7.07-12.24z"
        />
        <path
          fill="#F18700"
          d="m36.68 7.22-7.07 12.24-12.25-7.07z"
        />
        <path
          fill="#F7A941"
          d="m22.54 31.71 7.07-12.25 12.25 7.08z"
        />
        <path
          fill="#F18700"
          d="m-1.95 17.57 12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m22.54 31.71-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="m17.36 12.39-7.07 12.25-12.24-7.07zM3.22 36.89l7.07-12.25 12.25 7.07zM31.51-12.1l12.24 7.07-7.07 12.25z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Reparatie_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgReparatie);

export default ForwardRef;
